export const billEn = {
  tariffCloud: 'Cloud',
  licenseExpiresIn: 'Paid license expires in',
  freeUsers: '10 users',
  forFree: 'For free',
  addUsers: 'Add more users',
  totalUser: 'Total users',
  byLicense: 'License till',
  tillExpiration: 'left',
  forUsers: 'Total for',
  buyLicense: 'Add users',
  usersResult: 'Total user count will be',
  hitUserLimit: 'You hit user limit',
  hitUserLimitExplain: (count: number) =>
    `You got license with ${count} available. To add more, please, upgrade your license.`,
  hitUserLimitExplain1: 'You got license with',
  hitUserLimitExplain2: 'available. To add more, please, upgrade your license.',
  userLimitWarn: 'Add users to your license to invite more people',
  goToPrices: 'Go to prices details',
  fullName: 'Company name',
  address: 'Company address',
  tin: 'TIN (INN)',
  trrc: 'TRRC (KPP)',
  accNum: 'Account number',
  corrAccNum: 'Corr. acc. number',
  rcbic: 'RCBIC'
}

export const billRu: typeof billEn = {
  tariffCloud: 'Облачная версия',
  licenseExpiresIn: 'Оплаченная лицензия заканчивается через',
  freeUsers: '10 пользователей',
  forFree: 'Бесплатно',
  addUsers: 'Добавить ещё пользователей',
  totalUser: 'Всего пользователей',
  byLicense: 'По лицензии до',
  tillExpiration: 'до окончания',
  forUsers: 'Всего за',
  buyLicense: 'Добавление пользователей',
  usersResult: 'Пользователей станет',
  hitUserLimit: 'Лимит сотрудников исчерпан',

  hitUserLimitExplain: (count: number) =>
    `${count} доступно по текущей лицензии. Чтобы добавить пользователей, необходимо расширить лицензию`,
  hitUserLimitExplain1: '',
  hitUserLimitExplain2:
    'доступно по текущей лицензии. Чтобы добавить ' +
    'пользователей, необходимо расширить лицензию',
  userLimitWarn:
    'Добавьте пользователей к лицензии, чтобы пригласить больше пользователей',
  goToPrices: 'Посмотреть тарифы и расчёт цен',

  fullName: 'Полное наименование',
  address: 'Адрес компании',
  tin: 'ИНН',
  trrc: 'КПП',
  accNum: 'Номер расчётного счёта',
  corrAccNum: 'Номер корр. счёта',
  rcbic: 'БИК'
}
